import { FC, CSSProperties } from 'react';

type CopyIconProps = {
  style?: CSSProperties;
  className?: string;
};

const CopyIcon: FC<CopyIconProps> = ({ style, className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={ style }
      className={ className }
    >
      <path
        // eslint-disable-next-line max-len
        d="M14 12C14.2652 12 14.5196 11.8946 14.7071 11.7071C14.8946 11.5196 15 11.2652 15 11V2C15 1.73478 14.8946 1.48043 14.7071 1.29289C14.5196 1.10536 14.2652 1 14 1H5C4.73478 1 4.48043 1.10536 4.29289 1.29289C4.10536 1.48043 4 1.73478 4 2M2 15H11C11.5523 15 12 14.5523 12 14V5C12 4.44772 11.5523 4 11 4H2C1.44772 4 1 4.44772 1 5V14C1 14.5523 1.44772 15 2 15Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
